import { makeObservable, observable, action, reaction } from 'mobx';
import axios, { storeGet } from "../utils/axios";

class chatStore {
  main_window={};
  float_window=null;
  float_options={};

  window='contacts_list';
  opened_windows=[];
  ws_cmd={};
  new_messages={ fetching: false,inited: false, data:[]};
  par=null;

  constructor(par) {
    this.par=par;
    makeObservable(this, {
      main_window: observable,
      window: observable,
      new_messages: observable,
      opened_windows: observable,
      ws_cmd: observable,
      float_window: observable,
      float_options: observable,
    })
  }
  closeChatWindow(id) {
    const index=this.opened_windows.indexOf(id);
    if(index>-1) {
      this.opened_windows.splice(index,1);
    }
  }
  appendOpenedWindow(chatId) {
    this.opened_windows.push(chatId);
  }
  fetchNewMessages() {
    storeGet('/api/privatechat/new_messages', this.new_messages);
  }


}

export default chatStore;
